export const ut = {
  /**
   * Get Element by id from document or shadow DOM
   * @param {string} id String that specifies the ID value.
   * @return {HTMLElement} HtmlElement
   */
  gI: id => (window['shadowCalc'] || document).getElementById(id),

  qS: selector => document.querySelector(selector),

  /**
   * получить html шаблона
   *
   * @param {string} selector
   * @return {string}
   */
  gT: selector => {
    let node = ut.qS(selector);
    return node ? node.content.children[0].outerHTML : 'Not found template' + selector
  },

  /**
   * Получить Node шаблона
   * @param {string} selector
   * @returns {Node}
   */
  gTNode: selector => ut.qS(selector).content.children[0].cloneNode(true),

  /**
   * Маска для телефона
   * @param {HTMLElement} node
   */
  initMask: (node) => {
    const minValue = 2,
          matrix = '+7(___)___-__-__';

    if (!node) return;

    const mask = e => {
      let target = e.target, i = 0,
          def = matrix.replace(/\D/g, ""),
          val = target.value.replace(/\D/g, "");

      if (def.length >= val.length) val = def;
      target.value = matrix.replace(/./g,
        a => /[_\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? "" : a );

      if (e.type === "blur" && target.value.length <= minValue) target.value = "";
    };

    node.dataset.mask = matrix;
    ['input', 'blur'].map(e => node.addEventListener(e, mask));
  },

  /**
   * Random int number
   * @param {number} min - from number or count digit
   * @param {number} max - until number or undefined
   * @return {number}
   */
  random: (min = 5, max= 0) => {
    return max ? Math.floor(Math.random() * (max - min + 1) + min)
      : Math.random() * Math.pow(10, min) | 0;
  },

  /**
   * Добавить иконку загрузки
   * @param {HTMLElement} node
   * @param {boolean?} isLight
   */
  setLoading: (node, isLight = false) => {
    if (!(node instanceof HTMLElement)) {
      console.warn('Loading - node is not HTMLElement');
      return;
    }

    const isSingleTag = ['INPUT', 'HR', 'IMG'].includes(node.tagName),
          cStyle = window.getComputedStyle(node),
          c = node.getBoundingClientRect(),
          side = Math.min(c.width, c.height),
          size = side > 150 ? '-big' : side < 40 ? '-sm' : '';

    if (cStyle.position === 'fixed') {
      const loaderW = document.createElement('div'),
            loader  = document.createElement('div');

      loaderW.id = 'cmsLoaderWrapper';
      loaderW.style.cssText = `position: fixed;
        left: ${node.offsetLeft}px; top: ${node.offsetTop}px;
        z-index: ${typeof cStyle.zIndex === "number" ? cStyle.zIndex + 1 : +1}`;
      loader.style.cssText = `width: ${c.width}px; height: ${c.height}px;`;

      loaderW.append(loader);
      document.body.append(loaderW);
      node = loader;
    } else if (isSingleTag) {
      const loader = document.createElement('div');

      loader.id = 'cmsLoaderWrapper';
      loader.style.cssText = `display: ${cStyle.display}; width: ${c.width}px; height: ${c.height}px;`;

      node.after(loader);
      loader.append(node);
      node = loader;
    }

    node.classList.add('loading-st1' + size);
    isLight && node.classList.add('loading-st1-light');
  },
  /**
   * Удалить иконку загрузки
   * @param {HTMLElement} node
   */
  removeLoading: node => {
    if (!(node instanceof HTMLElement)) {
      console.warn('Loading - node is not HTMLElement');
      return;
    }

    if (window.getComputedStyle(node).position === 'fixed') {
      ut.gI('cmsLoaderWrapper').remove();
    }
    if (['INPUT', 'HR', 'IMG'].includes(node.tagName)) {
      node.parentNode['after'](node);
      ut.gI('cmsLoaderWrapper').remove();
    } else {
      node.classList.remove('loading-st1', 'loading-st1-sm', 'loading-st1-big', 'loading-st1-light');
    }
  },
}


export function initLoader() {
  const nodes = document.querySelectorAll('.loader-st1');

  nodes.forEach(n => {
    const target = n.previousElementSibling,
          size = target && target.getBoundingClientRect();

    if (!target) return;

    n.parentNode.style.position = 'relative';
    n.style.height = size.height + 'px';
    n.style.width = size.width + 'px';
  });
}

/* Проверка поддержки webp, добавление класса webp или no-webp для HTML */
export function isWebp() {
  // Проверка поддержки webp
  function testWebP(callback) {
    let webP = new Image();
    webP.onload = webP.onerror = function () {
      callback(webP.height === 2);
    };
    webP.src =
      "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
  }
  // Добавление класса _webp или _no-webp для HTML
  testWebP(function (support) {
    let className = support === true ? "webp" : "no-webp";
    document.documentElement.classList.add(className);
  });
}
/* Проверка мобильного браузера */
export let isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};
/* Добавление класса touch для HTML если браузер мобильный */
export function addTouchClass() {
  // Добавление класса _touch для HTML если браузер мобильный
  if (isMobile.any()) document.documentElement.classList.add("touch");
}
// Получение хеша в адресе сайта
export function getHash() {
  if (location.hash) {
    return location.hash.replace("#", "");
  }
}
// Указание хеша в адресе сайта
export function setHash(hash) {
  history.pushState("", "", hash);
}
// Учет плавающей панели на мобильных устройствах при 100vh
export function fullVHfix() {
  const fullScreens = document.querySelectorAll("[data-fullscreen]");
  if (fullScreens.length && isMobile.any()) {
    window.addEventListener("resize", fixHeight);
    function fixHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    fixHeight();
  }
}
// Вспомогательные модули плавного расскрытия и закрытия объекта =======================================================
export let _slideUp = (target, duration = 500, showmore = 0) => {
  if (!target.classList.contains("_slide")) {
    target.classList.add("_slide");
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = `${target.offsetHeight}px`;
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = showmore ? `${showmore}px` : `0px`;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.hidden = !showmore;
      !showmore ? target.style.removeProperty("height") : null;
      target.style.removeProperty("padding-top");
      target.style.removeProperty("padding-bottom");
      target.style.removeProperty("margin-top");
      target.style.removeProperty("margin-bottom");
      !showmore ? target.style.removeProperty("overflow") : null;
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      target.classList.remove("_slide");
    }, duration);
  }
};
export let _slideDown = (target, duration = 500, showmore = 0) => {
  if (!target.classList.contains("_slide")) {
    target.classList.add("_slide");
    target.hidden = target.hidden ? false : null;
    showmore ? target.style.removeProperty("height") : null;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = showmore ? `${showmore}px` : `0px`;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      target.classList.remove("_slide");
    }, duration);
  }
};
export let _slideToggle = (target, duration = 500) => {
  if (target.hidden) {
    return _slideDown(target, duration);
  } else {
    return _slideUp(target, duration);
  }
};
// Вспомогательные модули блокировки прокрутки и скочка ================================================================
export let bodyLockStatus = true;
export let bodyLockToggle = (delay = 500) => {
  if (document.documentElement.classList.contains("lock")) {
    bodyUnlock(delay);
  } else {
    bodyLock(delay);
  }
};
export let bodyUnlock = (delay = 500) => {
  let body = document.querySelector("body");
  if (bodyLockStatus) {
    let lock_padding = document.querySelectorAll("[data-lp]");
    setTimeout(() => {
      for (let index = 0; index < lock_padding.length; index++) {
        const el = lock_padding[index];
        el.style.paddingRight = "0px";
      }
      body.style.paddingRight = "0px";
      document.documentElement.classList.remove("lock");
    }, delay);
    bodyLockStatus = false;
    setTimeout(function () {
      bodyLockStatus = true;
    }, delay);
  }
};
export let bodyLock = (delay = 500) => {
  let body = document.querySelector("body");
  if (bodyLockStatus) {
    let lock_padding = document.querySelectorAll("[data-lp]");
    for (let index = 0; index < lock_padding.length; index++) {
      const el = lock_padding[index];
      el.style.paddingRight =
        window.innerWidth -
        document.querySelector(".wrapper").offsetWidth +
        "px";
    }
    body.style.paddingRight =
      window.innerWidth - document.querySelector(".wrapper").offsetWidth + "px";
    document.documentElement.classList.add("lock");

    bodyLockStatus = false;
    setTimeout(function () {
      bodyLockStatus = true;
    }, delay);
  }
};
// Модуь работы со спойлерами ==========================================================================================
/*
Для родителя слойлеров пишем атрибут data-spollers
Для заголовков слойлеров пишем атрибут data-spoller
Если нужно включать\выключать работу спойлеров на разных размерах экранов
пишем параметры ширины и типа брейкпоинта.

Например:
data-spollers="992,max" - спойлеры будут работать только на экранах меньше или равно 992px
data-spollers="768,min" - спойлеры будут работать только на экранах больше или равно 768px

Если нужно что бы в блоке открывался болько один слойлер добавляем атрибут data-one-spoller
*/
export function spollers() {
  const spollersArray = document.querySelectorAll("[data-spollers]");
  if (spollersArray.length > 0) {
    // Получение обычных слойлеров
    const spollersRegular = Array.from(spollersArray).filter(function (item) {
      return !item.dataset.spollers.split(",")[0];
    });
    // Инициализация обычных слойлеров
    if (spollersRegular.length > 0) {
      initSpollers(spollersRegular);
    }
    // Получение слойлеров с медиа запросами
    const spollersMedia = Array.from(spollersArray).filter(function (item) {
      return item.dataset.spollers.split(",")[0];
    });
    // Инициализация слойлеров с медиа запросами
    if (spollersMedia.length > 0) {
      const breakpointsArray = [];
      spollersMedia.forEach((item) => {
        const params = item.dataset.spollers;
        const breakpoint = {};
        const paramsArray = params.split(",");
        breakpoint.value = paramsArray[0];
        breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : "max";
        breakpoint.item = item;
        breakpointsArray.push(breakpoint);
      });
      // Получаем уникальные брейкпоинты
      let mediaQueries = breakpointsArray.map(function (item) {
        return (
          "(" +
          item.type +
          "-width: " +
          item.value +
          "px)," +
          item.value +
          "," +
          item.type
        );
      });
      mediaQueries = mediaQueries.filter(function (item, index, self) {
        return self.indexOf(item) === index;
      });
      // Работаем с каждым брейкпоинтом
      mediaQueries.forEach((breakpoint) => {
        const paramsArray = breakpoint.split(",");
        const mediaBreakpoint = paramsArray[1];
        const mediaType = paramsArray[2];
        const matchMedia = window.matchMedia(paramsArray[0]);
        // Объекты с нужными условиями
        const spollersArray = breakpointsArray.filter(function (item) {
          if (item.value === mediaBreakpoint && item.type === mediaType) {
            return true;
          }
        });
        // Событие
        matchMedia.addEventListener("change", function () {
          initSpollers(spollersArray, matchMedia);
        });
        initSpollers(spollersArray, matchMedia);
      });
    }
    // Инициализация
    function initSpollers(spollersArray, matchMedia = false) {
      spollersArray.forEach((spollersBlock) => {
        spollersBlock = matchMedia ? spollersBlock.item : spollersBlock;
        if (matchMedia.matches || !matchMedia) {
          spollersBlock.classList.add("_spoller-init");
          initSpollerBody(spollersBlock);
          spollersBlock.addEventListener("click", setSpollerAction);
        } else {
          spollersBlock.classList.remove("_spoller-init");
          initSpollerBody(spollersBlock, false);
          spollersBlock.removeEventListener("click", setSpollerAction);
        }
      });
    }
    // Работа с контентом
    function initSpollerBody(spollersBlock, hideSpollerBody = true) {
      const spollerTitles = spollersBlock.querySelectorAll("[data-spoller]");
      if (spollerTitles.length > 0) {
        spollerTitles.forEach((spollerTitle) => {
          if (hideSpollerBody) {
            spollerTitle.removeAttribute("tabindex");
            if (!spollerTitle.classList.contains("_spoller-active")) {
              spollerTitle.nextElementSibling.hidden = true;
            }
          } else {
            spollerTitle.setAttribute("tabindex", "-1");
            spollerTitle.nextElementSibling.hidden = false;
          }
        });
      }
    }
    function setSpollerAction(e) {
      const el = e.target;
      if (el.hasAttribute("data-spoller") || el.closest("[data-spoller]")) {
        const spollerTitle = el.hasAttribute("data-spoller")
          ? el
          : el.closest("[data-spoller]");
        const spollersBlock = spollerTitle.closest("[data-spollers]");
        const oneSpoller = spollersBlock.hasAttribute("data-one-spoller");
        if (!spollersBlock.querySelectorAll("._slide").length) {
          if (
            oneSpoller &&
            !spollerTitle.classList.contains("_spoller-active")
          ) {
            hideSpollersBody(spollersBlock);
          }
          spollerTitle.classList.toggle("_spoller-active");
          _slideToggle(spollerTitle.nextElementSibling, 500);
        }
        e.preventDefault();
      }
    }
    function hideSpollersBody(spollersBlock) {
      const spollerActiveTitle = spollersBlock.querySelector(
        "[data-spoller]._spoller-active"
      );
      if (spollerActiveTitle) {
        spollerActiveTitle.classList.remove("_spoller-active");
        _slideUp(spollerActiveTitle.nextElementSibling, 500);
      }
    }
  }
}

// Меню бургер =========================================================================================================
export function menuInit() {
  const btnMenu = document.querySelector("#mobileMenu");

  if (btnMenu) {
    const menu = document.querySelector(".header-nav"),
          btnClose = menu.querySelector('.btn');

    btnMenu.addEventListener("click", function () {
      if (bodyLockStatus) {
        const cl = document.documentElement.classList;

        btnMenu.classList.toggle('menu-open');
        menu.classList.toggle('menu-open');

        cl.contains('catalog-open') && cl.remove('catalog-open');
        cl.contains('sub-menu-open') && cl.remove('sub-menu-open');
      }
    });

    btnClose.addEventListener("click", function () {
      if (bodyLockStatus) {
        btnMenu.classList.remove('menu-open');
        menu.classList.remove('menu-open');
      }
    });
  }
}

// "показать еще" ======================================================================================================
/*
Документация по работе в шаблоне:
data-showmore="size/items"
data-showmore-content="размер/кол-во"
data-showmore-button="скорость"
Сниппет (HTML): showmore
*/
export function showMore() {
  const showMoreBlocks = document.querySelectorAll("[data-showmore]");
  if (showMoreBlocks.length) {
    initItems(showMoreBlocks);
    document.addEventListener("click", showMoreActions);
    window.addEventListener("resize", showMoreActions);
  }
  function initItems(showMoreBlocks) {
    showMoreBlocks.forEach((showMoreBlock) => {
      initItem(showMoreBlock);
    });
  }
  function initItem(showMoreBlock) {
    const showMoreContent = showMoreBlock.querySelector(
      "[data-showmore-content]"
    );
    const showMoreButton = showMoreBlock.querySelector(
      "[data-showmore-button]"
    );
    const hiddenHeight = getHeight(showMoreBlock, showMoreContent);
    if (hiddenHeight < getOriginalHeight(showMoreContent)) {
      _slideUp(showMoreContent, 0, hiddenHeight);
      showMoreButton.hidden = false;
    }
  }
  function getHeight(showMoreBlock, showMoreContent) {
    let hiddenHeight = 0;
    const showMoreType = showMoreBlock.dataset.showmore
      ? showMoreBlock.dataset.showmore
      : "size";
    if (showMoreType === "items") {
      const showMoreTypeValue = showMoreContent.dataset.showmoreContent
        ? showMoreContent.dataset.showmoreContent
        : 3;
      const showMoreItems = showMoreContent.children;
      for (let index = 1; index < showMoreItems.length; index++) {
        const showMoreItem = showMoreItems[index - 1];
        hiddenHeight += showMoreItem.offsetHeight;
        if (index === showMoreTypeValue) break;
      }
    } else {
      hiddenHeight = showMoreContent.dataset.showmoreContent
        ? showMoreContent.dataset.showmoreContent
        : 150;
    }
    return hiddenHeight;
  }
  function getOriginalHeight(showMoreContent) {
    let hiddenHeight = showMoreContent.offsetHeight;
    showMoreContent.style.removeProperty("height");
    let originalHeight = showMoreContent.offsetHeight;
    showMoreContent.style.height = `${hiddenHeight}px`;
    return originalHeight;
  }
  function showMoreActions(e) {
    const targetEvent = e.target;
    const targetType = e.type;
    if (targetType === "click") {
      if (targetEvent.closest("[data-showmore-button]")) {
        const showMoreButton = targetEvent.closest("[data-showmore-button]");
        const showMoreBlock = showMoreButton.closest("[data-showmore]");
        const showMoreContent = showMoreBlock.querySelector(
          "[data-showmore-content]"
        );
        const showMoreSpeed = showMoreBlock.dataset.showmoreButton
          ? showMoreBlock.dataset.showmoreButton
          : "500";
        const hiddenHeight = getHeight(showMoreBlock, showMoreContent);
        if (!showMoreContent.classList.contains("_slide")) {
          showMoreBlock.classList.contains("_showmore-active")
            ? _slideUp(showMoreContent, showMoreSpeed, hiddenHeight)
            : _slideDown(showMoreContent, showMoreSpeed, hiddenHeight);
          showMoreBlock.classList.toggle("_showmore-active");
        }
      }
    } else if (targetType === "resize") {
      initItems(showMoreBlocks);
    }
  }
}
